var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"full-height",staticStyle:{"margin-top":"80px"},attrs:{"fluid":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.redirectClick}},[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }